import * as React from "react"
import * as styles from "./styles.module.scss"
import goldmansachs from "./images/goldmansachs.png"
import iaventures from "./images/iaventures.png"
import kpcb from "./images/kpcb.png"
import pinebrook from "./images/pinebrook.png"

const EquityInvestors: React.FC = () => {
  return (
    <section className={styles.equityInvestors}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Our equity investors</h2>
        </div>
        <ul className={styles.list}>
          <li className={styles.item}>
            <a
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.goldmansachs.com/"
            >
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={goldmansachs}
                  alt="Goldman Sachs"
                />
              </figure>
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.iaventures.com/"
            >
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={iaventures}
                  alt="IA Venturs"
                />
              </figure>
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kpcb.com/"
            >
              <figure className={styles.figure}>
                <img
                  className={styles.image}
                  src={kpcb}
                  alt="Kleiner Perkins"
                />
              </figure>
            </a>
          </li>
          <li className={styles.item}>
            <a
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.pinebrookpartners.com/"
            >
              <figure className={styles.figure}>
                <img className={styles.image} src={pinebrook} alt="Pinebrook" />
              </figure>
            </a>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default EquityInvestors
